import { render, staticRenderFns } from "./CUVehicleType.vue?vue&type=template&id=b6eddb38&scoped=true&"
import script from "./CUVehicleType.vue?vue&type=script&lang=js&"
export * from "./CUVehicleType.vue?vue&type=script&lang=js&"
import style0 from "./CUVehicleType.vue?vue&type=style&index=0&id=b6eddb38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6eddb38",
  null
  
)

export default component.exports